import { FormikValues } from 'formik'

export interface CreateIssuerComplianceRuleValues extends FormikValues {
  rating: string
  ratingType: string
  maxLimit: number
}

export const createIssuerComplianceRuleValues: CreateIssuerComplianceRuleValues = {
  rating: null,
  ratingType: null,
  maxLimit: 0,
}
